import * as types from '../actions/types';
import uniq from 'lodash/uniq';

const INITIAL_STATE = {
  allMessages: [],
  selectedConversationId: '',
  blockedWordsFound: [],
  overridableWordsFound: [],
};

const conversation = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.ADD_MESSAGE:
      return {
        ...state,
        blockedWordsFound: [],
        overridableWordsFound: [],
        allMessages: uniq([...state.allMessages, action.message.messageId]),
        [action.message.messageId]: action.message,
      };

    case types.UPDATE_MESSAGE:
      return {
        ...state,
        [action.message.messageId]: action.message,
      };

    case types.SET_CONVERSATION_BLOCKED_WORDS_FOUND:
      return {
        ...state,
        blockedWordsFound: action.payload,
      };

    case types.SET_CONVERSATION_OVERRIDABLE_WORDS_FOUND:
      return {
        ...state,
        overridableWordsFound: action.payload,
      };

    case types.LOAD_CONVERSATION:
    case types.SHOW_CONVERSATION:
      return action.conversation;

    case types.EMPTY_CONVERSATION:
      return {
        allMessages: [],
        selectedConversationId: '',
        blockedWordsFound: [],
        overridableWordsFound: [],
      };

    default:
      return state;
  }
};

export default conversation;
